/* eslint-disable no-unused-vars */
import { useReducer } from 'react';
import * as types from '../ACContext/ACTypes';
import * as cnsts from '../AutocodeConstants';

const AutocodeSelectionAction = (state, dispatch) => {
  /// insertPos = -1 means insert at the end
  const insertLeafNode = (
    nodes,
    parentNodeID = cnsts.AC_ROOT_NODE_ID,
    insertionPos = -1
  ) => {
    // returns a datapoint leafnode generated from the inputList
    dispatch({
      type: types.AC_CREATE_LEAF_NODE,
      payload: {
        parentNodeID,
        nodes,
        insertionPos,
      },
    });
  };

  const insertDefinitionNodes = (
    nodes,
    parentNodeID = cnsts.AC_ROOT_NODE_ID,
    insertionPos = -1
  ) => {
    // returns a datapoint leafnode generated from the inputList
    dispatch({
      type: types.AC_CREATE_DEFINITION_NODE,
      payload: {
        parentNodeID,
        nodes,
        insertionPos,
      },
    });
  };

  const insertOperatorNode = (
    nodes,
    operatorSelected,
    parentNodeID = cnsts.AC_ROOT_NODE_ID,
    combine,
    insertionPos = -1
  ) => {
    dispatch({
      type: types.AC_CREATE_OPERATOR_NODE,
      payload: {
        parentNodeID,
        nodes,
        operatorSelected,
        combine,
        insertionPos,
      },
    });
  };

  const insertFunctionNodes = (
    functionName,
    isSelected,
    editable,
    params, // extra data for a function
    nodes,
    asIndividuals = false,
    parentNodeID = cnsts.AC_ROOT_NODE_ID,
    insertionPos = -1
  ) => {
    dispatch({
      type: types.AC_CREATE_FUNC_NODE,
      payload: {
        functionName,
        isSelected,
        editable,
        params,
        nodes,
        asIndividuals,
        parentNodeID,
        insertionPos,
      },
    });
  };

  const changeFunctionOfSelectedNodes = (
    functionName,
    isSelected,
    editable,
    params
  ) => {
    dispatch({
      type: types.AC_CHANGE_FUNC_OF_SELECTED_NODES,
      payload: {
        functionName,
        isSelected,
        editable,
        params,
      },
    });
  };

  const removeNodesByIds = nodeIds => {
    dispatch({
      type: types.AC_REMOVE_NODE_BY_ID,
      payload: {
        nodeIds,
      },
    });
  };

  const clearSelectionBox = () => {
    dispatch({
      type: types.AC_CLEAR_SELECTION_BOX,
    });
  };

  const removeSelectedNodes = () => {
    dispatch({
      type: types.AC_REMOVE_SELECTED_NODES,
    });
  };

  const removeAllNodes = () => {
    dispatch({
      type: types.AC_REMOVE_ALL_NODES,
    });
  };

  const setNodeSelectionById = (nodeId, selected) => {
    dispatch({
      type: types.AC_TOGGLE_SELECTED_NODE,
      payload: {
        nodeId,
        selected,
      },
    });
  };

  const selectAllNodes = (selected, deep = false) => {
    dispatch({
      type: types.AC_SELECT_ALL_NODES,
      payload: {
        selected,
        deep,
      },
    });
  };

  const selectAllNodesByType = (selected, type, deep = false) => {
    dispatch({
      type: types.AC_SELECT_ALL_NODES_BY_TYPE,
      payload: {
        selected,
        type,
        deep,
      },
    });
  };

  const mergeSelectedNodes = (
    operatorSelected,
    removeSourceNodes = true,
    insertionPos = -1
  ) => {
    dispatch({
      type: types.AC_MERGE_SELECTED_NODES,
      payload: {
        operatorSelected,
        removeSourceNodes,
        insertionPos,
      },
    });
  };

  const combineSelectedIntoNetAny = (
    operatorSelected,
    removeSourceNodes = true,
    insertionPos = -1
  ) => {
    dispatch({
      type: types.AC_MERGE_SELECTED_NETANY,
      payload: {
        operatorSelected,
        removeSourceNodes,
        insertionPos,
      },
    });
  };

  const splitSelectedNodes = () => {
    dispatch({
      type: types.AC_SPLIT_SELECTED_NODE,
    });
  };

  const splitSelectedOpNodes = () => {
    dispatch({
      type: types.AC_SPLIT_SELECTED_OP_NODE,
    });
  };

  const selectAllOperators = (isSelected = false) => {
    dispatch({
      type: types.AC_SELECT_ALL_OPERATORS,
      payload: {
        isSelected,
      },
    });
  };

  const changeSelectedOperator = (newOperator, isSelected = false) => {
    dispatch({
      type: types.AC_CHANGE_SELECTED_OPERATOR,
      payload: {
        newOperator,
        isSelected,
      },
    });
  };

  const changeSelectedOperatorById = (
    newOperator,
    nodeId,
    isSelected = false
  ) => {
    dispatch({
      type: types.AC_CHANGE_SELECTED_OPERATOR_BY_ID,
      payload: {
        newOperator,
        nodeId,
        isSelected,
      },
    });
  };

  const duplicateSelectedNodes = () => {
    dispatch({
      type: types.AC_DUPLICATE_SELECTED_NODES,
    });
  };

  const copySelectedNodes = () => {
    dispatch({
      type: types.AC_COPY_SELECTED_NODES,
    });
  };

  const pasteCopiedNodes = () => {
    dispatch({
      type: types.AC_PASTE_COPIED_NODES,
    });
  };

  const setOverrideLabelById = (nodeId, label, useOverride = true) => {
    dispatch({
      type: types.AC_SET_OVERRIDE_LABEL_BY_ID,
      payload: {
        nodeId,
        label,
        useOverride,
      },
    });
  };

  const setupBulkJoin = () => {
    dispatch({
      type: types.AC_SETUP_BULK_JOIN,
    });
  };

  const cancelBulkJoinSetup = () => {
    dispatch({
      type: types.AC_CANCEL_BULK_JOIN_SETUP,
    });
  };

  const mergeBulkJoin = (
    operatorSelected,
    removeSourceNodes = true,
    insertionPos = -1
  ) => {
    dispatch({
      type: types.AC_MERGE_BULK_JOIN,
      payload: {
        operatorSelected,
        removeSourceNodes,
        insertionPos,
      },
    });
  };

  const removeFunctionById = nodeId => {
    dispatch({
      type: types.AC_REMOVE_FUNCTION_NODE_BY_ID,
      payload: {
        nodeId,
      },
    });
  };

  const selectAllFunctions = isSelected => {
    dispatch({
      type: types.AC_SELECT_ALL_FUNCTIONS,
      payload: {
        isSelected,
      },
    });
  };

  const selectFunctionById = (nodeId, selected) => {
    dispatch({
      type: types.AC_SELECT_FUNCTION_BY_ID,
      payload: {
        nodeId,
        selected,
      },
    });
  };

  const setSelectedLabelType = labelObj => {
    dispatch({
      type: types.AC_SELECTED_LABEL_TYPE,
      payload: {
        labelObj,
      },
    });
  };

  const selectAllTemplateOperatorsByType = (templateNum, operatorType) => {
    dispatch({
      type: types.AC_SELECT_ALL_TEMPLATE_OPERATORS_BY_TYPE,
      payload: {
        templateNum,
        operatorType,
      },
    });
  };

  const insertNodes = (nodes, parentNodeID, insertionPos) => {
    dispatch({
      type: types.AC_INSERT_NODES,
      payload: {
        parentNodeID,
        nodes,
        insertionPos,
      },
    });
  };
  const setSelectionBoxDefinitionNodes = (data) => {
    dispatch({
      type: types.SET_DEFINITION_NODES,
      payload: data,
    });
  };

  const setBackToRootNode = (data, dispatch) => {
    dispatch({
      type: types.SET_BACK_TO_ROOTNODE,
      payload: data,
    });
  };

  const setBackToRootNodeAfterCancel = (data) => {
    dispatch({
      type: types.SET_BACK_TO_ROOTNODE,
      payload: data,
    });
  };


  const insertOperatorNetAnyNode = (
    functionName,
    nodes,
    parentNodeID = cnsts.AC_ROOT_NODE_ID,
    insertionPos = -1,
    params
  ) => {
    // returns a datapoint leafnode generated from the inputList
    dispatch({
      type: types.AC_OPERATORS_NETANY,
      payload: {
        functionName,
        parentNodeID,
        nodes,
        insertionPos,
        params,
      },
    });
  };
  // for single netany
  const insertNetanyLeafNode = (
    functionName,
    isSelected,
    editable,
    // params, // extra data for a function
    nodes,
    asIndividuals = false,
    parentNodeID = cnsts.AC_ROOT_NODE_ID,
    insertionPos = -1
  ) => {
    // returns a datapoint leafnode generated from the inputList
    dispatch({
      type: types.AC_CREATE_NETANY_LEAF_NODE,
      payload: {
        functionName,
        isSelected,
        editable,
        // params,
        nodes,
        asIndividuals,
        parentNodeID,
        insertionPos,
      },
    });
  };
  const removeNetany = nodeId => {
    dispatch({
      type: types.AC_REMOVE_NETANY,
      payload: {
        nodeId,
      },
    });
  };
  return {
    insertLeafNode,
    insertOperatorNode,
    insertDefinitionNodes,
    insertFunctionNodes,
    setNodeSelectionById,
    selectAllNodes,
    selectAllNodesByType,
    mergeSelectedNodes,
    combineSelectedIntoNetAny,
    splitSelectedNodes,
    splitSelectedOpNodes,
    removeSelectedNodes,
    removeAllNodes,
    removeNodesByIds,
    clearSelectionBox,
    selectAllOperators,
    changeSelectedOperator,
    changeSelectedOperatorById,
    duplicateSelectedNodes,
    copySelectedNodes,
    pasteCopiedNodes,
    setOverrideLabelById,
    setupBulkJoin,
    cancelBulkJoinSetup,
    mergeBulkJoin,
    removeFunctionById,
    changeFunctionOfSelectedNodes,
    selectAllFunctions,
    selectFunctionById,
    setSelectedLabelType,
    selectAllTemplateOperatorsByType,
    insertNodes,
    insertOperatorNetAnyNode,
    insertNetanyLeafNode,
    removeNetany,
    setSelectionBoxDefinitionNodes,
    setBackToRootNode,
    setBackToRootNodeAfterCancel
  };
};

export default AutocodeSelectionAction;

// const createFuncNode = (inputNode, funcName, funcType) => {
//   // one input node will be wrapped in function
//   // i.e. SUM, SUMAX, QUOTIENT, MEAN
//   dispatch({
//     type: types.AC_CREATE_OPERATOR_NODE,
//     payload: {
//       node: inputNode,
//       func: funcName,
//     },
//   });
// };

// const createBRangeNode = (inputNode, suffix) => {
//   // one input node will be wrapped in brange
//   // and a suffix will be added to the end
// };
